
















































import { defineComponent, PropType, computed, ref, getCurrentInstance } from '@vue/composition-api';
import { SearchIcon } from 'tdesign-icons-vue';

import { SMH } from '@/renderer/scripts/smh';
import store from '@/renderer/store';
import { isDisabledAllAuth } from '@/renderer/scripts/utils/tools/index';

import HeaderOperation from './HeaderOperation.vue';
import BaseTable, { BaseTableRef } from './BaseTable.vue';

export interface MemberTableRef {
  selectedNum: number;
  initData: () => void;
  resetData: () => void;
  removeSelected: () => void;
}

export default defineComponent({
  name: 'MemberTable',
  components: {
    SearchIcon,
    HeaderOperation,
    BaseTable,
  },
  props: {
    loading: {
      required: true,
      type: Boolean,
    },
    asyncLoading: {
      required: false,
      type: String,
      default: '',
    },
    data: {
      required: true,
      type: Array as PropType<CoFile.TeamOrMemberItem[]>,
      default: [],
    },
    getMembers: {
      required: true,
      type: Function as PropType<(searchKey?: string, isInit?: boolean) => void>,
    },
    /** 是否允许管理员设置权限 */
    canAdminSetRole: {
      type: Boolean,
      default: false,
    },
    /** 可进行授权操作 */
    canAuth: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit, root }) {
    const vm = getCurrentInstance()?.proxy || root;
    const routeName = computed(() => vm.$route.name as string);

    const baseTableRef = ref<BaseTableRef | undefined>();
    const roleLoading = ref(false);
    const selectedNum = computed(() => (baseTableRef.value?.selectedUids || []).length);
    const searchKeyCache = ref('');
    let searchKey = '';

    const roleOptions = computed(() => {
      if (!props.canAuth) return undefined;

      return (store.getters.roles as SMH.Role[]).filter(role => {
        // 协作空间权限详情不显示操作者和禁止访问角色
        if (routeName.value.includes('collaborationSpace')) {
          return !role.canAuthorize && !isDisabledAllAuth(role);
        }
        if (['teamManagement'].includes(routeName.value)) {
          // 团队管理页面隐藏禁止访问者入口
          return !isDisabledAllAuth(role);
        }

        return true;
      });
    });

    const methods = {
      initData() {
        props.getMembers();
        if (props.canAuth) {
          methods.initRoleList();
        }
      },
      initRoleList() {
        roleLoading.value = true;
        // 每次初始化成员权限列表时都重新拉取一次全局权限列表
        store
          .dispatch('GetRoles')
          .then(data => {
            roleLoading.value = false;
          })
          .catch(() => {
            roleLoading.value = false;
          });
      },
      searchMember(searchKeyCache: string, isInit = false) {
        if (searchKeyCache === searchKey) return;

        searchKey = searchKeyCache;
        props.getMembers(searchKeyCache, isInit);
      },
      onRemoveMember(index: number, item: CoFile.TeamOrMemberItem) {
        emit('remove', index, item);
      },
      onBatchRemove() {
        emit('batchRemove');
      },
      onRoleChange(roleId: number, item: CoFile.TeamOrMemberItem) {
        emit('roleChange', roleId, item.uid);
      },
      onBatchRoleChange(roleId: number) {
        emit('batchRoleChange', roleId);
      },
      onSelectChange(uids: string[], selectedList: CoFile.TeamOrMemberItem[]) {
        emit('selectChange', uids, selectedList);
      },
      onLoadMoreClick() {
        emit('loadMoreClick');
      },
      removeSelected() {
        baseTableRef.value?.removeSelected();
      },
    };

    return {
      roleLoading,
      roleOptions,
      searchKeyCache,
      selectedNum,
      baseTableRef,

      ...methods,
    };
  },
});
